<template>
  <div>
    <div class="loader" v-if="answerLoader">
      <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner>
    </div>
    <div v-else>
      <b-table striped responsive :fields="fields" :items="items">
        <template>
          <b-tr>
            <!--
            <b-th></b-th>
            <b-th></b-th>
            -->
            <b-th></b-th>
            <b-th></b-th>
            <b-th></b-th>
            <b-th></b-th>
            <b-th style="width: 80px"></b-th>
          </b-tr>
        </template>
        <!--
        <template v-slot:cell(action)="row">
          {{ row.item.action.name }}
        </template>
        -->
        <template v-slot:cell(date)="row">
          {{ dateFormat(row.item.date) }}
        </template>
        <template v-slot:cell(grade)="row">
          <div v-if="myMetric === 'like-dislike'">
            <span v-if="row.item.grade === 1">
              <img
                alt="Like"
                width="40"
                height="40"
                src="../../../../../assets/Like.svg"
              />
            </span>
            <span v-if="row.item.grade === 0">
              <img
                alt="Deslike"
                width="40"
                height="40"
                src="../../../../../assets/Deslike.svg"
              />
            </span>
          </div>
          <div v-else class="flag-grade" :class="`flag-grade-${group}`">
            {{ row.item.grade }}
          </div>
        </template>
        <template v-slot:cell(client)="row">
          {{ returnClient(row.item.anonymousResponse, row.item.client) }}
          <!-- {{
            !row.item.anonymousResponse
              ? row.item.client
              : `${$t('reports.wordCloud.anonimousLabel')}`
          }} -->
        </template>
        <!--
        <template v-slot:cell(status)="row">
          <div>
            <b-badge
              v-if="!row.item.status"
              variant="primary"
              style="color: #fff;"
              >Ativo</b-badge
            >
            <b-badge v-else variant="secondary">Inativo</b-badge>
          </div>
        </template>
        -->
        <template v-slot:cell(details)="row">
          <div class="text-center">
            <div v-if="userProfile.permissions.answers.menu">
              <a :href="`/treatments/${row.item.id}`" target="_blank">
                <i
                  style="cursor: pointer; color: #4ce595"
                  class="fas fa-search"
                ></i
              ></a>
            </div>
          </div>
        </template>
      </b-table>
      <div class="row no-gutters" v-if="wordSelected === null">
        <div class="col-12">
          <p class="text-center">
            {{ this.$t('reports.wordCloud.noDataMessage') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { format } from 'date-fns';
import pt from 'date-fns/locale/pt';

export default {
  props: {
    wordSelected: {
      type: String,
    },
    action: {
      type: Boolean,
    },
    group: {
      type: String,
    },
    ih1: {
      type: String,
    },
    ih2: {
      type: String,
    },
  },
  data: () => ({
    userAuth: null,
    fields: [],
    items: [],
    answerLoader: false,
  }),
  watch: {
    wordSelected: function watchWordSelected(value) {
      if (value !== null) {
        this.answerLoader = true;
        this.setListAnswersWordcloud({
          token: this.userAuth.token,
          companyId: this.userAuth.companyId,
          params: {
            groupId: this.actionGroupData._id,
            actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
            word: value,
            group: this.group,
            startDate: this.calendarDates.start
              ? this.calendarDates.start
              : null,
            endDate: this.calendarDates.end ? this.calendarDates.end : null,
            ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
            ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
            metric: this.myMetric,
            indicator: this.indicatorName,
            indicatorValue: this.indicatorData.value,
            indicatorRange: this.indicatorData.range,
          },
        }).then(() => {
          if (this.listAnswersWordcloud.length > 0) {
            this.items = this.listAnswersWordcloud;
          } else {
            this.items = [];
          }
          this.answerLoader = false;
        });
      } else {
        this.items = [];
      }
    },
    group: function watchGroup(value) {
      if (this.userProfile.permissions.answers.menu) {
        if (value !== null) {
          this.answerLoader = true;
          this.setListAnswersWordcloud({
            token: this.userAuth.token,
            companyId: this.userAuth.companyId,
            params: {
              groupId: this.actionGroupData._id,
              actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
              word: this.wordSelected,
              group: value,
              startDate: this.calendarDates.start
                ? this.calendarDates.start
                : null,
              endDate: this.calendarDates.end ? this.calendarDates.end : null,
              ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
              ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
              metric: this.myMetric,
              indicator: this.indicatorName,
              indicatorValue: this.indicatorData.value,
              indicatorRange: this.indicatorData.range,
            },
          }).then(() => {
            if (this.listAnswersWordcloud.length > 0) {
              this.items = this.listAnswersWordcloud;
            } else {
              this.items = [];
            }
            this.answerLoader = false;
          });
        } else {
          this.items = [];
        }
      }
    },
  },
  computed: {
    ...mapState('answers', ['listAnswersWordcloud']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
    ...mapState('authentication', ['userProfile']),
  },
  methods: {
    ...mapActions('answers', ['setListAnswersWordcloud']),

    returnClient(isAnonymous, client) {
      if (this.userProfile.permissions.answers.menu) {
        if (
          isAnonymous &&
          !this.userProfile.permissions.answers.anonymous_profile
        ) {
          return 'Anônimo';
        } else if (this.userProfile.permissions.answers.anonymous_profile) {
          return '****';
        } else if (client) {
          return client;
        }
      }

      if (this.userProfile.permissions.answers.anonymous_profile) {
        return '****';
      }

      return '****';
    },
    dateFormat(param) {
      const date = format(new Date(param), 'dd/MM/yyyy HH:mm', { locale: pt });
      return date;
    },
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.fields = [
      { key: 'feedback', label: this.$t('reports.wordCloud.commentLabel') },
      { key: 'date', label: this.$t('reports.wordCloud.dateLabel') },
      { key: 'grade', label: this.$t('reports.wordCloud.gradeLabel') },
      { key: 'client', label: this.$t('reports.wordCloud.customerLabel') },
      { key: 'details', label: this.$t('reports.wordCloud.detailsLabel') },
    ];
  },
};
</script>

<style scoped lang="scss">
.flag-grade {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: white;
  font-weight: bold;
  font-size: 16px;
  margin-left: auto;
  margin-right: auto;
  max-width: 35px;
  max-height: 30px;
  padding: 4px;
}

.flag-category-text {
  text-transform: lowercase;
}

.flag-category-close {
  cursor: pointer;
}

.flag-grade-promoters {
  background-color: #28a745;
}

.flag-grade-detractors {
  background-color: #dc3545;
}

.flag-grade-neutrals {
  background-color: rgb(211, 211, 17);
}

.flag-grade-invalid {
  background-color: #c1c1c1;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/word-cloud/list-answers/index.vue